<template>
  <v-container fluid>
    <v-card>
      <v-toolbar dense flat color="secondary">
        <v-toolbar-title>Profit Report</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="blue" small text to="/import-buying-prices">
          <v-icon left dark>mdi-cog</v-icon> Import Buying Prices
        </v-btn>
        <v-btn color="accent" small text to="/manage-buying-prices">
          <v-icon left dark>mdi-cog</v-icon> Buying Prices
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-row class="subtitle-2 text--primary">
          <v-col cols="12" xs="12" md="4">
            <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
              offset-y min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field dense outlined single-line v-model="date" label="From" prepend-icon="mdi-calendar-month"
                  v-on="on" readonly></v-text-field>
              </template>
              <v-date-picker @change="getRecords" v-model="date" @input="menu1 = false"></v-date-picker>
            </v-menu><br>

            <v-autocomplete autocomplete="off" name="owner" hide-details dense outlined v-model="owner" :items="owners"
              label="Owner" item-text="name" item-value="id" @change="getRecords"></v-autocomplete>
          </v-col>

          <v-col cols="12" md="4" class="section-bg">
            <v-simple-table dense>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td>Total Shop Sales</td>
                    <td>{{ SalesReportData.TotalShopSales | currency }}</td>
                  </tr>
                  <tr>
                    <td>Outsourced Sales</td>
                    <td>{{ SalesReportData.TotalOutsourcedSales | currency }}</td>
                  </tr>
                  <tr>
                    <td>Net Sales</td>
                    <td>{{ SalesReportData.TotalSales | currency }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>


          <v-col cols="12" md="4" class="section-bg">
            <v-simple-table dense>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td>Shop Profit</td>
                    <td>{{ SalesReportData.ShopSalesProfit | currency }}</td>
                  </tr>
                  <tr>
                    <td>Outsourced Profit</td>
                    <td>{{ SalesReportData.OutsourcedProfit | currency }}</td>
                  </tr>
                  <tr>
                    <td>Net Profit</td>
                    <td>{{ SalesReportData.TotalProfit | currency }}</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>

        </v-row>


        <v-row dense class="subtitle-2 text--primary">
          <v-col cols="12">
            <v-text-field name="Search" v-model="search" label="Search" dense></v-text-field>
            <!-- start of table -->
            <v-data-table :mobile-breakpoint="0" :items-per-page="pageItems" :headers="headers" :items="soldProducts"
              :search="search">
              <!-- template -->
              <template v-slot:item.Price="{ item }">
                {{
                  item.Price.toLocaleString()
                }}
              </template>
              <!-- end -->


              <!-- template -->
              <!-- <template v-slot:item.PaymentModes="{ item }">
               <div v-for="(value, index) in item.document.rct1" v-bind:key="index">
                {{ value.oact.Name }}  {{ value.SumApplied.toLocaleString() }}  ref: {{ value.PaymentRemarks }}
               </div>
              </template> -->
              <!-- end -->

              <!-- action template -->
              <template v-slot:item.DocNum="{ item }">
                <v-btn color="accent" text :to="`/pos/sale-details/${item.InvoiceId}`">{{ item.DocNum }}</v-btn>
              </template>
              <!-- end -->

              <!-- template -->
              <template v-slot:item.LineTotal="{ item }">
                {{
                  item.LineTotal | currency
                }}
              </template>
              <!-- end -->

              <!-- date template -->
              <template v-slot:item.Date="{ item }">
                {{
                  item.Date | date
                }}
              </template>
              <!-- end -->

              <!-- date template -->
              <template v-slot:item.profit="{ item }">
                {{
                  (item.Price - item.BuyingPrice) * item.Quantity | currency
                }}
              </template>
              <!-- end -->

            </v-data-table>
          </v-col>
        </v-row>

        <v-row>
          <v-divider></v-divider>
        </v-row>

        <v-row class="subtitle-2 text--primary">
          <v-col cols="12">
            <h3>Outsourced Products</h3>
          </v-col>

          <v-col cols="12" style="margin-top: -10px">
            <v-data-table :mobile-breakpoint="0" :items-per-page="pageItems" :headers="outsourcedHeaders"
              :items="outsourcedData" :search="search">

              <!-- action template -->
              <template v-slot:item.DocNum="{ item }">
                <v-btn color="accent" text :to="`/pos/sale-details/${item.invoice.id}`">{{ item.invoice.DocNum
                  }}</v-btn>
              </template>
              <!-- end -->

              <!-- template -->
              <template v-slot:item.Quantity="{ item }">
                <span>
                  {{
                    item.Quantity.toLocaleString()
                  }}
                </span>
              </template>
              <!-- end -->

              <!-- template -->
              <template v-slot:item.Price="{ item }">
                <span>
                  {{
                    item.Price | currency
                  }}
                </span>
              </template>
              <!-- end -->
              <!-- template -->
              <template v-slot:item.LineTotal="{ item }">
                <span>
                  {{
                    item.LineTotal | currency
                  }}
                </span>
              </template>
              <!-- end -->

              <!-- template -->
              <template v-slot:item.Date="{ item }">
                <span>
                  {{
                    item.Date | date
                  }}
                </span>
              </template>
              <!-- end -->
            </v-data-table>
          </v-col>
        </v-row>

        <!-- snackbar -->
        <snackbar ref="snackbar"></snackbar>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import jsPDF from "jspdf";
import "jspdf-autotable";
import { http } from "@/common/index";
export default {
  data() {
    return {
      search: null,
      record: {},
      SalesReportData: {},
      loader: false,
      summaryDialog: false,
      pageItems: 2000,
      date: new Date().toISOString().substr(0, 10),
      menu1: false,
      menu2: false,
      menu3: false,
      owner: null,
      owners: [],
      summaryData: [],
      outsourcedData: [],
      headers: [
        { text: "Invoice No.", value: "DocNum" },
        { text: "Product", value: "ProductName" },
        { text: "Qty", value: "Quantity" },
        { text: "UOM", value: "Unit" },
        { text: "Buying Price", value: "BuyingPrice" },
        { text: "Selling Price", value: "Price" },
        { text: "Total", value: "LineTotal" },
        { text: "Profit", value: "profit" },
        { text: "Customer", value: "CustomerName" },
        // { text: "Sold By", value: "SoldBy" },
        { text: "Date", value: "Date" }
      ],
      summaryHeaders: [
        { text: "Item Name", value: "product" },
        { text: "Opening Stock", value: "openingQty" },
        { text: "Total Purchase", value: "totalBought" },
        { text: "Transfer In", value: "transIn" },
        { text: "Total Sold", value: "totalSold" },
        { text: "Transfer Out", value: "transOut" },
        { text: "Closing Stock", value: "closingQty" }
      ],
      outsourcedHeaders: [
        { text: "Invoice No.", value: "DocNum" },
        { text: "Item Name", value: "Name" },
        { text: "Quantity", value: "Quantity" },
        { text: "Unit", value: "UomName" },
        { text: "BuyingPrice", value: "BuyingPrice" },
        { text: "SellingPrice", value: "Price" },
        { text: "Total", value: "LineTotal" },
        { text: "Customer", value: "invoice.Customer.Name" },
        { text: "Date", value: "Date" }
      ],
      fields: {
        product: "product",
        openingQty: "openingQty",
        totalGiven: "transIn",
        totalSold: "totalSold",
        closingQty: "closingQty"
      },
      returnHeaders: [
        { text: "Doc Num", value: "id" },
        { text: "Customer", value: "ocrd" },
        { text: "Product", value: "product" },
        { text: "Qty", value: "Quantity" },
        { text: "Price", value: "Price" },
        { text: "Total", value: "LineTotal" },
        { text: "User", value: "User" }
      ],
      soldProducts: [],
      totalSales: null,
      returnsData: [],
      TotalReturns: null
    };
  },
  computed: {
    totalSalesValue() {
      let total = 0;
      if (this.totalSales) {
        total = this.totalSales.toLocaleString();
      }
      return total;
    },
    storeName() {
      return localStorage.getItem("storeName");
    }
  },
  methods: {
    setDate(date) {
      this.date = date;
    },
    thermalPrint() {
      const data = this.record;
      const url = "/stock-movement-analysis/available/14";
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            let details = {
              storeName: self.storeName,
              stock: res.ResponseData,
              date: self.record.EndDate
            };
            self.printLocalInventory(details);
            self.loader = false;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
            self.loader = false;
          }
          self.loader = false;
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    printLocalInventory(stock) {
      return http.post(
        "http://localhost/stalispos-receipt/src/inventory/ClosingData.php",
        {
          stock
        }
      );
    },
    printSummary() {
      // const shopName = this.storeName;
      var doc = new jsPDF({ compress: true });
      var totalPagesExp = "{total_pages_count_string}";
      // var pageHeight =
      //   doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
      var pageWidth =
        doc.internal.pageSize.width || doc.internal.pageSize.getWidth();

      var img = new Image();
      img.src = require("@/assets/stock.png");
      doc.addImage(img, "png", 10, 5, 100, 40);

      doc.setFontSize(15);
      doc.setTextColor(0, 0, 0);
      doc.setFont("Georgia, serif");
      // doc.text(shopName, pageWidth - 50, 15, "center");

      //Setting Items Title:
      doc.setFontSize(15);
      doc.text("Stock Analysis Report", pageWidth / 2, 57, "center");

      doc.setFontSize(13);
      doc.text(
        "From: " + "2020-10-01" + "   " + "To: " + "2020-10-15",
        pageWidth / 2,
        62,
        "center"
      );
      doc.setFontSize(12);

      // Vairables to Hold Data
      let dataRows = [];

      // Columns
      var columns = [
        { title: "Product", dataKey: "product" },
        { title: "Opening Qty", dataKey: "openingQty" },
        { title: "Total Purchases", dataKey: "totalBought" },
        { title: "Transfer In", dataKey: "transIn" },
        { title: "Total Sales", dataKey: "totalSold" },
        { title: "Transfer Out", dataKey: "transOut" },
        { title: "Closing Qty", dataKey: "closingQty" }
      ];

      doc.setTextColor(0, 0, 0);
      doc.setFontSize(11);
      doc.setFont("Georgia, serif");

      const allData = this.summaryData;
      dataRows = allData.map(alldata => {
        return {
          product: alldata.product,
          openingQty: alldata.openingQty,
          totalBought: alldata.totalBought,
          transIn: alldata.transIn,
          totalSold: alldata.totalSold,
          transOut: alldata.transOut,
          closingQty: alldata.closingQty
        };
      });

      doc.setTextColor(0, 0, 0);
      doc.setFontSize(11);
      doc.setFont("Georgia, serif");
      doc.text("RECORDS", 15, 70);
      doc.autoTable(columns, dataRows, {
        theme: "grid",
        startY: 75,
        didDrawPage: function (data) {
          // Header
          doc.setFontSize(20);
          doc.setTextColor(40);

          // Footer
          var str = "Page " + doc.internal.getNumberOfPages();
          // Total page number plugin only available in jspdf v1.0+
          if (typeof doc.putTotalPages === "function") {
            str = str + " of " + totalPagesExp;
          }
          doc.setFontSize(10);

          // jsPDF 1.4+ uses getWidth, <1.4 uses .width
          var pageSize = doc.internal.pageSize;
          var pageHeight = pageSize.height
            ? pageSize.height
            : pageSize.getHeight();
          doc.text(str, data.settings.margin.left, pageHeight - 10);
          //Setting Foouter
          doc.setTextColor(22, 160, 133);
          doc.setFontSize(10);
          var today = new Date();
          doc.text("" + today, pageWidth / 2, pageHeight - 5, "center");
        }
      });
      // Total page number plugin only available in jspdf v1.0+
      if (typeof doc.putTotalPages === "function") {
        doc.putTotalPages(totalPagesExp);
      }
      window.open(doc.output("bloburl"), "_blank");
    },
    getReport() {
      const data = this.record;
      const url = "/stock-movement-analysis/14";
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.summaryData = res.ResponseData;
            self.loader = false;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
            self.loader = false;
          }
          self.loader = false;
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getRecords() {
      const self = this;
      const DocDate = this.date;
      const data = {
        StartDate: DocDate,
        SoldBy: null,
        ProductID: null,
        CustomerID: null,
        combinedReport: "N",
        owner: self.owner
      };


      this.$store.commit("loader", true);
      const url = `/daily-sold-products-report`;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.SalesReportData = res.ResponseData;
            self.soldProducts = res.ResponseData.SoldProducts;
            self.totalSales = res.ResponseData.TotalSales;
            self.outsourcedData = res.ResponseData.OutsourcedSales;
            self.$store.commit("loader", false);
          } else {
            this.$refs.snackbar.show(res.msg, "red");
            self.$store.commit("loader", false);
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    returnedProducts() {
      const data = {
        StartDate: new Date().toISOString().substr(0, 10),
        EndDate: new Date().toISOString().substr(0, 10),
        CustomerID: null
      };
      const self = this;
      const url = `/returned-products-report`;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.returnsData = res.ResponseData.AllSales;
            self.TotalReturns = res.ResponseData.TotalReturns;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getOwners() {
      const self = this;
      this.$store
        .dispatch("get", `/get-owner-users`)
        .then(res => {
          console.log(res.ResponseData);
          self.owners = res.ResponseData;
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    }
  },
  created() {
    this.getOwners();
    this.getRecords();
    // this.returnedProducts();
  }
};
</script>

<style lang="scss" scoped></style>